import { render, staticRenderFns } from "./Telefones.vue?vue&type=template&id=f185ad04&"
import script from "./Telefones.vue?vue&type=script&lang=js&"
export * from "./Telefones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports